import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitoindorecab() {



    const cardData = {




keyword: "Mumbai to Indore Cab",

headingDescription: "Shreesha Tours & Travels provides reliable, affordable, and comfortable Mumbai to Indore cab services for business travelers, families, tourists, corporate professionals, students, and long-distance travelers. We offer one-way cabs, round-trip taxi services, airport transfers, corporate travel, multi-city journeys, and customized Madhya Pradesh tour packages with experienced chauffeurs and well-maintained vehicles. Our fleet includes Sedan, Swift Dzire, Ertiga, SUV, Innova, Innova Crysta, Tempo Traveller, Urbania, Mini Bus, and luxury vehicles suitable for solo travelers, families, and large groups. With doorstep pickup anywhere in Mumbai, flexible departure schedules, transparent pricing, easy online booking, and 24/7 customer support, Shreesha Tours & Travels ensures a safe, smooth, and hassle-free journey. Whether you are traveling for business meetings, educational purposes, medical visits, family functions, religious tours, or sightseeing, our Mumbai to Indore cab service provides professional drivers, clean vehicles, and personalized travel solutions. Enjoy a comfortable road trip with premium travel comfort, flexible stopovers, and dependable service from Mumbai to the commercial capital of Madhya Pradesh.",

topPlaces: [
  {
    title: "Rajwada Palace",
    description: "Rajwada Palace is one of Indore's most iconic historical landmarks, showcasing magnificent Maratha architecture and centuries of royal heritage. The seven-story palace attracts visitors with its grand entrance, beautiful courtyards, cultural significance, and evening light-and-sound shows."
  },
  {
    title: "Lal Bagh Palace",
    description: "Lal Bagh Palace is a magnificent royal residence built by the Holkar dynasty and is known for its luxurious European-style interiors, antique furniture, chandeliers, and beautifully landscaped gardens. It is one of Indore's finest heritage attractions."
  },
  {
    title: "Sarafa Bazaar",
    description: "Sarafa Bazaar is India's most famous night street food market, offering delicious Indori delicacies such as poha, jalebi, bhutte ka kees, garadu, malpua, and many other local specialties. It is a must-visit destination for food lovers."
  },
  {
    title: "Khajrana Ganesh Temple",
    description: "Khajrana Ganesh Temple is one of the most revered temples in Indore, attracting thousands of devotees every day. The temple is believed to fulfill wishes and is known for its peaceful atmosphere and beautiful architecture."
  },
  {
    title: "Annapurna Temple",
    description: "Annapurna Temple is a famous Hindu temple dedicated to Goddess Annapurna. The temple is admired for its grand entrance, beautifully carved elephants, intricate architecture, and spiritual ambiance."
  },
  {
    title: "Patalpani Waterfall",
    description: "Patalpani Waterfall is a spectacular natural attraction located near Indore, surrounded by lush green hills and scenic landscapes. It is especially popular during the monsoon season and is a favorite picnic destination for families and nature lovers."
  },
  {
    title: "Ralamandal Wildlife Sanctuary",
    description: "Ralamandal Wildlife Sanctuary is one of Madhya Pradesh's oldest wildlife reserves, offering forest trails, bird watching, deer sightings, and panoramic viewpoints. It is a perfect destination for wildlife enthusiasts and adventure seekers."
  },
  {
    title: "Ujjain",
    description: "Located close to Indore, Ujjain is one of India's holiest cities and home to the famous Mahakaleshwar Jyotirlinga. Many travelers combine Indore and Ujjain in a single trip to experience spirituality, history, and culture."
  },
  {
    title: "Omkareshwar",
    description: "Omkareshwar is one of the twelve sacred Jyotirlingas of Lord Shiva, situated on the banks of the holy Narmada River. It is a major pilgrimage destination near Indore and is frequently included in religious tour itineraries."
  },
  {
    title: "Mandu",
    description: "Mandu is a historic hill town near Indore, renowned for its magnificent Afghan architecture, Jahaz Mahal, Hindola Mahal, ancient forts, and romantic heritage. It is one of Madhya Pradesh's most popular heritage tourism destinations."
  }
],



"services": [
  {
    "name": "Mumbai to Indore Cab",
    "description": "Book Mumbai to Indore Cab for safe, comfortable, and reliable interstate travel with experienced chauffeurs and well-maintained AC vehicles. Choose from Sedan, Ertiga, Innova, Innova Crysta, SUV, Kia Carens, and Tempo Traveller options for family vacations, corporate travel, business meetings, airport transfers, and one way or round trip journeys. Enjoy doorstep pickup, transparent pricing, and 24x7 customer support for a smooth road trip."
  },
  {
    "name": "Mumbai to Indore Taxi",
    "description": "Hire Mumbai to Indore Taxi for hassle-free long-distance travel with professional drivers, clean vehicles, and affordable travel packages. Our chauffeur-driven taxis are ideal for business trips, family tours, personal travel, and comfortable interstate transportation."
  },
  {
    "name": "Mumbai to Indore Cab Service",
    "description": "Choose Mumbai to Indore Cab Service for dependable outstation travel with premium AC vehicles, trained chauffeurs, and flexible booking options. Enjoy reliable transportation for business travel, family vacations, sightseeing, and long-distance journeys."
  },
  {
    "name": "Mumbai to Indore Taxi Service",
    "description": "Book Mumbai to Indore Taxi Service for smooth interstate transportation with experienced drivers, transparent pricing, and multiple vehicle choices. Travel comfortably with one way and round trip taxi services."
  },
  {
    "name": "Mumbai to Indore Cab Booking",
    "description": "Complete Mumbai to Indore Cab Booking online with instant confirmation, competitive pricing, and a wide range of vehicles. Select the perfect cab according to your travel needs and enjoy comfortable doorstep pickup."
  },
  {
    "name": "Mumbai to Indore Car Rental",
    "description": "Hire Mumbai to Indore Car Rental with chauffeur-driven vehicles for flexible and comfortable long-distance travel. Perfect for family vacations, business tours, corporate travel, and personal road trips."
  },
  {
    "name": "Mumbai to Indore Taxi Fare",
    "description": "Check Mumbai to Indore Taxi Fare with transparent pricing and affordable travel packages. Compare Sedan, Ertiga, Innova Crysta, SUV, Kia Carens, and Tempo Traveller options for economical and comfortable travel."
  },
  {
    "name": "Mumbai to Indore Cab Fare",
    "description": "Get the best Mumbai to Indore Cab Fare with competitive pricing, professional chauffeur service, and premium AC vehicles. Enjoy safe, comfortable, and budget-friendly interstate transportation."
  },
  {
    "name": "Mumbai to Indore One Way Cab",
    "description": "Book Mumbai to Indore One Way Cab for economical single-trip travel without paying return charges. Enjoy fixed fares, experienced chauffeurs, clean vehicles, and comfortable long-distance travel."
  },
  {
    "name": "Mumbai to Indore Round Trip Taxi",
    "description": "Reserve Mumbai to Indore Round Trip Taxi for convenient return journeys with flexible schedules and affordable packages. Perfect for business visits, family vacations, and sightseeing trips."
  },
  {
    "name": "Mumbai to Indore Outstation Cab",
    "description": "Choose Mumbai to Indore Outstation Cab for safe and reliable interstate travel with premium vehicles and experienced drivers. Travel comfortably with Sedan, Ertiga, Innova Crysta, SUV, and luxury cab options."
  },
  {
    "name": "Mumbai Airport to Indore Cab",
    "description": "Book Mumbai Airport to Indore Cab for reliable airport pickup and direct interstate travel with professional chauffeurs and comfortable AC vehicles. Enjoy timely pickup from all Mumbai airport terminals."
  },
  {
    "name": "Mumbai to Indore Car Hire",
    "description": "Hire Mumbai to Indore Car Hire for private chauffeur-driven transportation with spacious vehicles, flexible itineraries, and dependable customer support. Suitable for family, corporate, and executive travel."
  },
  {
    "name": "Mumbai to Indore Private Taxi",
    "description": "Reserve Mumbai to Indore Private Taxi for personalized travel with dedicated vehicles, premium comfort, and experienced chauffeurs. Enjoy complete privacy, flexible schedules, and a stress-free journey."
  },
  {
    "name": "Navi Mumbai to Indore Cab",
    "description": "Book Navi Mumbai to Indore Cab for comfortable interstate travel with premium AC vehicles, experienced drivers, and affordable fares. Ideal for business executives, families, and personal travel."
  },
  {
    "name": "Thane to Indore Taxi",
    "description": "Choose Thane to Indore Taxi for dependable long-distance transportation with clean AC cars, professional chauffeurs, and transparent pricing. Enjoy a comfortable and relaxing interstate journey."
  },
  {
    "name": "Mumbai to Indore Innova Cab",
    "description": "Hire Mumbai to Indore Innova Cab for spacious travel with comfortable seating, large luggage capacity, and experienced chauffeurs. Ideal for family groups, corporate teams, and long road trips."
  },
  {
    "name": "Mumbai to Indore Innova Crysta Cab",
    "description": "Book Mumbai to Indore Innova Crysta Cab for premium luxury travel with spacious interiors, advanced comfort, and professional chauffeur service. Perfect for executive travel, family holidays, and corporate transportation."
  },
  {
    "name": "Mumbai to Indore Ertiga Cab",
    "description": "Reserve Mumbai to Indore Ertiga Cab for affordable 6 to 7 seater travel with spacious interiors and comfortable seating. Ideal for family vacations, airport transfers, and group travel."
  },
  {
    "name": "Mumbai to Indore Sedan Cab",
    "description": "Choose Mumbai to Indore Sedan Cab for economical travel with clean AC vehicles and professional drivers. Suitable for solo travelers, couples, business executives, and smooth highway journeys."
  },
  {
    "name": "Mumbai to Indore SUV Cab",
    "description": "Book Mumbai to Indore SUV Cab for spacious and comfortable long-distance travel with extra luggage capacity, premium interiors, and experienced chauffeurs. Perfect for families and luxury travel."
  },
  {
    "name": "Mumbai to Indore Kia Carens Cab",
    "description": "Hire Mumbai to Indore Kia Carens Cab for stylish and spacious travel with premium comfort, modern features, and reliable chauffeur service. Enjoy a smooth and relaxing interstate journey."
  },
  {
    "name": "Mumbai to Indore Tempo Traveller",
    "description": "Reserve Mumbai to Indore Tempo Traveller for group travel, corporate outings, family vacations, and pilgrimage tours. Enjoy spacious seating, experienced drivers, and comfortable long-distance transportation."
  },
  {
    "name": "Mumbai to Indore Travel Service",
    "description": "Choose Mumbai to Indore Travel Service for reliable chauffeur-driven transportation with premium vehicles, flexible travel plans, and affordable pricing. Whether for business travel, family vacations, airport transfers, or leisure trips, enjoy a safe, comfortable, and hassle-free journey."
  },
  {
    "name": "Best Mumbai to Indore Cab Booking",
    "description": "Book the Best Mumbai to Indore Cab Booking with trusted chauffeur service, well-maintained AC vehicles, transparent pricing, and 24x7 customer support. Experience safe, punctual, and comfortable interstate travel with flexible one way and round trip booking options for business, family, and personal journeys."
  }
],
"tableData": [
  ["Mumbai to Indore Cab", "Mumbai to Indore Taxi"],
  ["Mumbai to Indore Cab Service", "Mumbai to Indore Taxi Service"],
  ["Mumbai to Indore Cab Booking", "Mumbai to Indore Car Rental"],
  ["Mumbai to Indore Taxi Fare", "Mumbai to Indore Cab Fare"],
  ["Mumbai to Indore One Way Cab", "Mumbai to Indore Round Trip Taxi"],
  ["Mumbai to Indore Outstation Cab", "Mumbai Airport to Indore Cab"],
  ["Mumbai to Indore Car Hire", "Mumbai to Indore Private Taxi"],
  ["Navi Mumbai to Indore Cab", "Thane to Indore Taxi"],
  ["Mumbai to Indore Innova Cab", "Mumbai to Indore Innova Crysta Cab"],
  ["Mumbai to Indore Ertiga Cab", "Mumbai to Indore Sedan Cab"],
  ["Mumbai to Indore SUV Cab", "Mumbai to Indore Kia Carens Cab"],
  ["Mumbai to Indore Tempo Traveller", "Mumbai to Indore Travel Service"],
  ["Best Mumbai to Indore Cab Booking", ""]
],




whychoose: [
  {
    WhyChooseheading: "Comfortable Mumbai to Indore Cab for Every Traveller",
    WhyChoosedescription: "Cover the journey from Mumbai to Indore with Shreesha Tours & Travels in a private taxi that combines comfort, reliability, and professional service for business, family, and leisure travel."
  },
  {
    WhyChooseheading: "Direct Pickup & Drop at Your Preferred Location",
    WhyChoosedescription: "Avoid the inconvenience of multiple transfers by booking a private cab with pickup from your home, office, hotel, airport, or railway station in Mumbai and drop anywhere in Indore."
  },
  {
    WhyChooseheading: "Choose the Right Vehicle for Your Journey",
    WhyChoosedescription: "Travel in Swift Dzire, Sedan, Ertiga, Innova, Innova Crysta, SUVs, Tempo Travellers, or luxury vehicles, selected according to your passenger count and travel comfort."
  },
  {
    WhyChooseheading: "Perfect for Business, Family & Religious Travel",
    WhyChoosedescription: "Our Mumbai to Indore taxi service is ideal for corporate travel, family visits, weddings, educational trips, medical travel, and pilgrimages to nearby destinations like Ujjain and Omkareshwar."
  },
  {
    WhyChooseheading: "Experienced Chauffeurs for Interstate Routes",
    WhyChoosedescription: "Our trained drivers have extensive knowledge of Maharashtra and Madhya Pradesh highway routes, ensuring a safe, smooth, and punctual journey."
  },
  {
    WhyChooseheading: "Flexible Travel Plans with Multiple Stopovers",
    WhyChoosedescription: "Book one-way cabs, round trips, or customized itineraries with optional stopovers based on your travel preferences and schedule."
  },
  {
    WhyChooseheading: "Comfortable Long-Distance Travel Experience",
    WhyChoosedescription: "Our well-maintained vehicles feature air-conditioned cabins, comfortable seating, and spacious luggage capacity, making long road journeys enjoyable."
  },
  {
    WhyChooseheading: "Reliable Booking Support from Shreesha Tours & Travels",
    WhyChoosedescription: "Receive quick quotations, transparent pricing, and dedicated customer assistance to make your Mumbai to Indore cab booking simple and stress-free."
  }
]

};

const faqData = [
  {
    question: "Can I travel directly from Mumbai to Indore by private cab?",
    answer: "Yes, Shreesha Tours & Travels provides direct private taxi service from Mumbai to any location in Indore with doorstep pickup and drop."
  },
  {
    question: "Is Mumbai to Indore cab service available for pilgrimage trips?",
    answer: "Yes, many travellers book our cabs for Indore along with visits to Ujjain Mahakal, Omkareshwar Jyotirlinga, and nearby religious destinations."
  },
  {
    question: "Which vehicle is suitable for a Mumbai to Indore road trip?",
    answer: "You can choose from Swift Dzire, Sedan, Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers based on your travel needs."
  },
  {
    question: "Can I include Ujjain or Omkareshwar in my travel itinerary?",
    answer: "Yes, customized routes with multiple destinations and sightseeing stops can be arranged on request."
  },
  {
    question: "Do you offer one-way and round-trip taxi services to Indore?",
    answer: "Yes, both one-way and round-trip cab services are available along with flexible multi-day travel packages."
  },
  {
    question: "Is airport pickup available before starting the journey?",
    answer: "Yes, pickup can be arranged from Mumbai Airport, railway stations, hotels, offices, homes, and other preferred locations."
  },
  {
    question: "Can corporate teams book larger vehicles for Indore travel?",
    answer: "Yes, Ertiga, Innova Crysta, SUVs, and Tempo Travellers are available for corporate groups and business delegations."
  },
  {
    question: "What factors affect the Mumbai to Indore taxi fare?",
    answer: "The fare depends on the selected vehicle, travel duration, trip type, route, and any customized stopovers included in your itinerary."
  },
  {
    question: "Do you provide overnight travel for Mumbai to Indore?",
    answer: "Yes, overnight interstate travel can be arranged with experienced drivers based on your preferred departure schedule."
  },
  {
    question: "How can I confirm my Mumbai to Indore cab booking?",
    answer: "Simply share your travel date, pickup point, destination, passenger details, and preferred vehicle to receive a quotation and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rajesh Agrawal",
    feedback: "I booked a Mumbai to Indore cab for a business trip. The driver was punctual, the sedan was clean, and the journey was comfortable throughout the interstate route.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Poonam Verma",
    feedback: "Our family travelled to Indore and later visited Ujjain with Shreesha Tours & Travels. The Innova Crysta was spacious, the itinerary was flexible, and the entire experience was excellent.",
    rating: 5
  }
];




















    const Images = [
        { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
        { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
        { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
        { place: "/images/keyword/5.jpg", text: "Mumbai to Nashik Cab", link: "Mumbai-to-Nashik-Cab" },
        { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
        { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
        { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
        { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
        { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
        { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
        { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
        { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
        { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
        { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
        { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
        { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
        { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
        { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
        { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
        { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
        { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
        { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
        { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
    ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Indore Cab",
  "image": "https://www.shreeshatravels.com/assets/images/mumbai-to-indore-cab.webp",
  "description":
    "Book Mumbai to Indore Cab with Shreesha Tours & Travels for safe, comfortable, and affordable outstation taxi services. We provide one-way and round-trip cabs from Mumbai to Indore with Sedan, Ertiga, SUV, Innova, and Innova Crysta available 24x7 for business travel, corporate trips, family vacations, airport transfers, and long-distance journeys.",
  "brand": {
    "@type": "Brand",
    "name": "Shreesha Tours & Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shreeshatravels.com/mumbai-to-indore-cab"
  }
};







    return (
        <div>
<Helmet>
  <title>Mumbai to Indore Cab | Intercity Taxi Service | +91 8355835813</title>

  <meta
    name="description"
    content="Book Mumbai to Indore Cab with Shreesha Travels for reliable one-way and round-trip taxi services. Hire Sedan, Ertiga, SUV, Innova, and Innova Crysta for affordable travel from Mumbai to Indore with 24x7 online cab booking and professional drivers."
  />

  <meta
    name="keywords"
    content="Mumbai to Indore Cab, Mumbai to Indore Taxi, Mumbai to Indore Cab Service, Mumbai to Indore Taxi Service, Mumbai to Indore Cab Booking, Mumbai to Indore Car Rental, Mumbai to Indore Taxi Fare, Mumbai to Indore Cab Fare, Mumbai to Indore One Way Cab, Mumbai to Indore Round Trip Cab, Mumbai to Indore Outstation Cab, Mumbai to Indore Taxi Booking"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>


















            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/28.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Shreesha Tours & Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Shreesha Tours & Travels</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shreesha Tours & Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918355835813 " className="pc-call">+91 8355835813 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919930929439 " className="pc-call">+91 9930929439 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919022432779 " className="pc-call">+91 9022432779 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/91919930929439 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918355835813 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@shreeshatravels.com" className="pc-email">
                                            booking@shreeshatravels.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Shreesha Tours & Travels</strong><br />
                                            Office 125, Saishraddha CHS,
                                            Plot No 47, Near Koparkhairane Police Station,
                                            Sector 5, Sector 4,Ghansoli, Navi Mumbai,
                                            Maharashtra, India- 400701




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Mumbaitoindorecab;